import { render, staticRenderFns } from "./recommend-layer.vue?vue&type=template&id=7593fc3d&scoped=true"
import script from "./recommend-layer.vue?vue&type=script&lang=js"
export * from "./recommend-layer.vue?vue&type=script&lang=js"
import style0 from "./recommend-layer.vue?vue&type=style&index=0&id=7593fc3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7593fc3d",
  null
  
)

export default component.exports